import type { ReactNode } from "react"
import { BREAKPOINTS } from "./breakpoints.ts"

export type ColumnPriority = "always" | "md" | "lg"

export type Column<T> = {
  key: string
  header: string
  /** 언제까지 보일지. 기본 always. md = 768 이상에서만, lg = 1024 이상에서만. */
  priority?: ColumnPriority
  align?: "start" | "end"
  /** 카드 배치에서 제목 줄로 올릴 칸. 한 표에 하나만 둔다. */
  primary?: boolean
  /** 서버가 정렬할 수 있는 칸이면 그 이름(`server/src/repos/case-query.ts` 의 SORTABLE). */
  sortKey?: string
  render: (row: T) => ReactNode
}

const MIN_WIDTH: Record<ColumnPriority, number> = {
  always: 0,
  md: BREAKPOINTS.md,
  lg: BREAKPOINTS.lg,
}

/** 이 폭에서 보여야 할 칸만 남긴다. */
export function visibleColumns<T>(columns: Column<T>[], width: number): Column<T>[] {
  return columns.filter((column) => width >= MIN_WIDTH[column.priority ?? "always"])
}

/** 이보다 좁으면 표를 버리고 행 하나를 카드로 그린다. 11칸짜리 표는 가로 스크롤로도 못 읽는다. */
export function isCardLayout(width: number): boolean {
  return width < BREAKPOINTS.sm
}

/**
 * 카드 배치에서 보여 줄 칸.
 *
 * 폭으로 거르지 않는다 — 카드는 세로로 쌓으므로 자리가 넉넉하다. 가로 표에서 자리가
 * 없어 밀려났던 md 칸을 되살리고, 부차적인 lg 칸만 뺀다.
 */
export function cardColumns<T>(columns: Column<T>[]): Column<T>[] {
  return visibleColumns(columns, BREAKPOINTS.lg - 1)
}
